import { ComponentProps } from "react";

import { useT } from "@/i18n";
import { Team } from "@/types";
import { getIconSize, IconSize } from "@/ui";
import { cn } from "@/utils/cn";
import { getAvatarPlaceholderUrl } from "@/utils/common";

export type TeamLogoProps = {
  team: Pick<Team, "title" | "image">;
  width?: number;
  height?: number;
  size?: IconSize;
} & Omit<ComponentProps<"img">, "src" | "alt" | "aria-label">;

export const TeamLogo = ({ team, className, width, height, size, ...props }: TeamLogoProps) => {
  const t = useT();

  const label = t("team.components.logo.label", {
    name: team.title,
  });

  const sizePx = getIconSize(size);

  return (
    <img
      src={team.image || getAvatarPlaceholderUrl(team.title)}
      alt={label}
      aria-label={label}
      style={{ width: width ?? sizePx, height: height ?? sizePx }}
      className={cn("shrink-0 object-contain rounded-sm", className)}
      {...props}
    />
  );
};
